import * as React from "react";
import type { SVGProps } from "react";
const SvgMessageChat01 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="#000"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      d="M4.533 10.933a8.533 8.533 0 1 1 16.341 3.447l.727 5.086-4.358-1.09a8.5 8.5 0 0 1-4.177 1.09M2.4 16.267c0 .767.162 1.496.453 2.155L2.4 21.6l2.724-.68A5.333 5.333 0 1 0 2.4 16.267"
    />
  </svg>
);
export default SvgMessageChat01;
